import { produce } from 'immer'
import {
  GET_USER_SAVED_FILTERS_FAILURE,
  GET_USER_SAVED_FILTERS_INIT,
  GET_USER_SAVED_FILTERS_SUCCESS,
  GetUserSavedFiltersActions,
} from 'src/app/ExpensesTransactions/redux/expensesTransactions.actions'

export interface SavedFiltersState {
  ids: string[]
  loading: boolean
}

export interface ExpensesTransactionsState {
  savedFilters: SavedFiltersState
}

export const initialState: ExpensesTransactionsState = {
  savedFilters: {
    ids: [],
    loading: false,
  },
}

export type Actions = GetUserSavedFiltersActions

const ExpensesTransactionsReducer = (
  state = initialState,
  action: Actions,
): ExpensesTransactionsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_USER_SAVED_FILTERS_INIT: {
        draft.savedFilters.loading = true
        return draft
      }

      case GET_USER_SAVED_FILTERS_SUCCESS: {
        draft.savedFilters.loading = false
        draft.savedFilters.ids = Array.from(
          new Set([
            // this is to de-dupe the ids
            ...draft.savedFilters.ids,
            ...action.payload.savedFilters.map((savedFilter) => savedFilter.id),
          ]),
        )
        return draft
      }

      case GET_USER_SAVED_FILTERS_FAILURE: {
        draft.savedFilters.loading = false
        return draft
      }
    }
  })
}

// route-less reducer as this acts as a sort of wrapper around transactionsAllTransactions and transactionsYourTransactions
export default ExpensesTransactionsReducer
